import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

const icon =
  '<svg width="40" height="40" viewBox="0 0 81 80" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="81" height="80" fill="#322018"/><path d="M21.5868 62.0479V50.9853H22.0258C27.1672 56.5145 33.8494 63.792 41.6376 63.792C46.9268 63.792 51.1861 60.7346 51.1861 55.4229C51.1861 49.237 45.1624 46.2549 36.9352 43.415C27.315 40.2154 21 35.485 21 27.99C21 20.495 27.7582 13 40.0969 13C47.0028 13 53.685 15.4007 58.0202 17.3665V28.0653H57.653C52.807 22.971 45.6816 16.0574 38.7756 16.0574C33.2669 16.0574 29.6662 19.5498 29.6662 23.5524C29.6662 28.9394 36.4244 31.8504 44.8711 34.9036C56.2558 39.3413 60 45.2386 60 51.5708C60 62.0479 50.8906 67 40.8314 67C34.9554 67 28.345 65.1095 21.5868 62.0521V62.0479Z" fill="white"/></svg>';

function setMap(mapElement) {
  const lat = parseFloat(mapElement.dataset.lat);
  const lng = parseFloat(mapElement.dataset.lng);

  if (Number.isNaN(lat) || Number.isNaN(lng)) return;

  const zoom = parseInt(mapElement.dataset.zoom, 10) || 15;
  const address = mapElement.dataset.address || '';
  const coords = [lat, lng];

  const map = L.map(mapElement, {
    attributionControl: false,
    scrollWheelZoom: false,
    zoomControl: false,
  }).setView(coords, zoom);

  L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png', {
    attribution: '',
  }).addTo(map);

  L.control.zoom({
    position: 'bottomright',
  }).addTo(map);

  const svgIcon = L.divIcon({
    className: 'custom-icon',
    html: icon,
    iconSize: [40, 40],
    iconAnchor: [20, 20],
    popupAnchor: [0, -20],
  });

  const marker = L.marker(coords, { icon: svgIcon }).addTo(map);

  if (address) {
    marker.bindPopup(address);
  }
}

document.querySelectorAll('.js-map').forEach(setMap);
